<template>
	<el-dialog :visible.sync="showdownmd" title="下载面单" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div class="downmd">
			<el-form ref="form" label-width="100px" size="mini">
				<el-form-item label="文件命名">
					<el-select v-model="filenamerule" style="width:100%">
						<el-option v-for="(item, index) in typelist" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="文件保存路径" v-if="downtype!='pdf'&&downtype!=null">
					<el-input placeholder="请输入保存路径" v-model="filepath" :readonly="true">
					     <el-button slot="append" @click="selpath">选择路径</el-button>
					  </el-input>
				</el-form-item>
				<el-form-item label="文件格式">
					<el-radio-group v-model="downtype">
						<el-radio label="pdf">pdf</el-radio>
						<el-radio label="jpg">jpg</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="padding-top:0px">
				<div style="text-align: center;">
					<el-button type="success" :disabled="btndisabled" size="mini" @click="godownmd">确 定</el-button>
					<el-button @click="showdownmd = false" size="mini">取 消</el-button>
				</div>
			</span>
		</div>
		<printhandler ref="printhandler" @printcallback="printcallback"></printhandler>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
import printhandler from '@/components/order/printhandler.vue';
export default {
	components: {
		printhandler
	},
	data() {
		return {
			showdownmd: false,
			btndisabled:false,
			downtype: localStorage.getItem('downtype'),
			typelist: [{ name: '订单号',value:'订单号' }, { name: '快递单号',value:'快递单号' }, { name: '快递单号M',value:'快递单号★M' }],
			filenamerule: localStorage.getItem('filenamerule'),
			pageparam: {},
			searchinfo: {},
			batch: '',
			divclass: 'downmd',
			filepath:localStorage.getItem('filepath'),
			sys:''
		};
	},
	methods: {
		init(param) {
			this.showdownmd = true;
			this.btndisabled=false;
			if (param.pageparam != undefined) this.pageparam = param.pageparam;
			if (param.searchinfo != undefined) this.searchinfo = param.searchinfo;
			if (param.batch != undefined) this.batch = param.batch;
			if (param.sys!=undefined) this.sys=param.sys;
		},
		//选择保存文件路径
		selpath(){
			var that=this;
			if (!this.$tool.checkprintcontrol()) {
				this.$tool.opendowncontrol();
			}else{
				LODOP.PRINT_INIT("");
				LODOP.ADD_PRINT_TABLE(100, 20, 500, 60,"<table><tr><td>验证</td></tr></table>");
				LODOP.SET_SAVE_MODE("RETURN_FILE_NAME", 1);
				if (LODOP.CVERSION) {
					LODOP.On_Return = function (TaskID, Value) {
						that.$tool.loadingclose();
						if (Value != "") {
							that.filepath=Value.replace("验证文件.xls", "");
						} else {
							that.$tool.message('设置失败，请重试', 0);
						}
					};
					LODOP.SAVE_TO_FILE("验证文件.xls");
					this.$tool.loading('正在设置', that.divclass);
				} else {
					var Value = LODOP.SAVE_TO_FILE("验证文件.xls");
					//this.$tool.loading('正在验证', that.divclass);
					if (Value != "") {
						//this.$tool.loadingclose();
						that.filepath=Value.replace("验证文件.xls", "");
					} else {
						//this.$tool.loadingclose();
						this.$tool.message("选择失败，请重试",0);
					}
				}
			}
		},
		godownmd() {
			//debugger
			var that=this;
			var filepath=this.filepath;
			var rules='';
			if (this.filenamerule == '') {
				this.$tool.message('请选择文件命名', 0);
				return false;
			}
			else{
				var rulelist=this.typelist.filter(function(e){return e.name==that.filenamerule});
				if(rulelist.length>0)
					rules=rulelist[0].value;
			}
			if (this.downtype == '') {
				this.$tool.message('请选择文件格式', 0);
				return false;
			}
			if(this.downtype!=''){
				if(this.downtype!='pdf'&&this.filepath=='')
				{
					this.$tool.message('请填写保存位置', 0);
					return false;
				}
				else if(this.downtype!='pdf'){
					localStorage.setItem('filepath', this.filepath);
				}
			}
			
			localStorage.setItem('downtype', this.downtype);
			localStorage.setItem('filenamerule', this.filenamerule);
			this.$tool.loading('正在生成', this.divclass);
			this.btndisabled=true;
			if (this.$refs.printhandler != undefined) {
				this.$refs.printhandler.init({
					pageparam: this.pageparam,
					isgrid: false,
					pkval: '',
					searchinfo: this.searchinfo,
					funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 14, //14-下载面单
					isrollback: false,
					parentpage: this,
					batch: this.batch,
					filenamerule: rules,
					downtype: this.downtype,
					filepath:filepath,
					sys:this.sys
				});
			}
		},
		printcallback(e) {
			if(e.issuccess){
				this.showdownmd=false;
			}else{
				this.btndisabled=false;
			}
		}
	}
};
</script>

<style></style>
